/**
 * @see https://advantech-curation.visualstudio.com/Marketplace/_wiki/wikis/Marketplace.wiki/336/Menus
 */

enum EnumMenuType {
  LINK = 1,
  DROPDOWN = 2,
}

enum EnumLinkTarget {
  BLANK = 1,
  SELF = 2,
}

// [GET] Menu

interface IMenu {
  name: string;
  type: EnumMenuType;
  link: {
    url: string;
    target: number;
  };
  subMenus: IMenu[];
}

// [GET] Solution Menu

interface ISolutionMenu {
  name: string;
  type: EnumMenuType;
  shortIntroduction: string | null;
  link: {
    url: string;
    target: EnumLinkTarget;
  };
  isHot: boolean;
  subMenus: ISolutionMenu[];
}

export { EnumLinkTarget, EnumMenuType };
export type { IMenu, ISolutionMenu };
